import { useOutboxStatus } from '@/offline/sender';
import { useAuth } from '@/stores/auth';
import { confirmAction, confirmDiscard } from '@/stores/confirm';
import { hasUnsavedWork } from '@/stores/unsaved';

/**
 * Signs out, asking first when a form holds unsaved typing, or when work saved
 * on this PC has not reached the server yet. That work is not lost — it stays
 * on this PC, sealed, and goes the next time this person signs in here with a
 * connection (.docs/023) — but nobody should find that out by surprise.
 */
export async function signOutSafely(): Promise<void> {
  if (hasUnsavedWork() && !(await confirmDiscard())) return;

  const { waiting, refused } = useOutboxStatus.getState();
  const unsent = waiting + refused;
  if (
    unsent > 0 &&
    !(await confirmAction({
      title: 'Some work is not sent yet',
      message:
        `${unsent} ${unsent === 1 ? 'piece of work is' : 'pieces of work are'} saved on this PC but not with the server yet. ` +
        'It stays on this PC and is sent the next time you sign in here with a connection.',
      confirmLabel: 'Sign out anyway',
      cancelLabel: 'Stay signed in',
    }))
  ) {
    return;
  }
  await useAuth.getState().signOut();
}
